var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLaryngoscope(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    clipRule: "evenodd",
    imageRendering: "optimizeQuality",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M190.5-.5h253c4.915 3.917 5.748 8.584 2.5 14-1.584 1.361-3.418 2.028-5.5 2v128c4.971.24 7.471 2.907 7.5 8 .5 98.666.667 197.333.5 296 4.971.24 7.471 2.907 7.5 8 .667 16 .667 32 0 48-.246 3.505-1.746 6.171-4.5 8h-128c-1.644-.816-2.81-2.15-3.5-4a783.858 783.858 0 010-56c1.539-3.021 4.039-4.354 7.5-4-.167-100.001 0-200.001.5-300 1.539-3.021 4.039-4.354 7.5-4 .167-13.337 0-26.671-.5-40-.5-4.5-3-7-7.5-7.5a9999.75 9999.75 0 00-200 0c-23.159 1.184-39.993 12.018-50.5 32.5a171.752 171.752 0 00-7 29c-8.078 4.29-13.245 2.123-15.5-6.5 4.292-71.608 39.958-119.941 107-145a253.036 253.036 0 0129-6.5z",
    opacity: 0.979
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#e5e8ec",
    d: "M192.5 15.5h231v88h-72c-.918-12.096-7.252-19.93-19-23.5-72-.667-144-.667-216 0-10.973 1.933-20.973 6.1-30 12.5l-1-1c22.894-43.215 58.561-68.549 107-76z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#cbd0d8",
    d: "M351.5 119.5h72v24h-72v-24z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#646c77",
    d: "M343.5 159.5h88v32h-88v-32z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#535c65",
    d: "M343.5 207.5h88v240h-88v-240z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#646d77",
    d: "M335.5 463.5h104v32h-104v-32z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaryngoscope);
export default __webpack_public_path__ + "static/media/laryngoscope.46493c49.svg";
export { ForwardRef as ReactComponent };